import { useState } from "react";
import { Lock } from "lucide-react";

export const LoginForm = ({ onLogin, error, loading }) => {
  const [password, setPassword] = useState("");

  const submit = (e) => {
    e.preventDefault();
    onLogin(password);
  };

  return (
    <div className="admin-page" data-testid="admin-login-page">
      <form className="admin-login-card" onSubmit={submit} data-testid="admin-login-form">
        <img src="/assets/brand/logo.png" alt="KR Studio" className="admin-logo" />
        <h1>Enquiry Dashboard</h1>
        <p>Private area — enter the admin password to view enquiries.</p>
        <div className="field">
          <label htmlFor="admin-password">Admin password</label>
          <input
            type="password"
            id="admin-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            data-testid="admin-password-input"
          />
        </div>
        {error && <div className="form-error" data-testid="admin-login-error">{error}</div>}
        <button type="submit" className="btn btn-primary btn-full" disabled={loading} data-testid="admin-login-btn">
          <Lock size={15} /> {loading ? "Signing in…" : "Sign in"}
        </button>
        <a href="/" className="admin-back" data-testid="admin-back-link">← Back to website</a>
      </form>
    </div>
  );
};
